import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Form, Input, Select, Checkbox, Space, Radio, Spin, AutoComplete, Button, message, Tag, Row, Col, Alert as AntAlert } from "antd";
import { PlusOutlined, DeleteOutlined, MailOutlined, PhoneOutlined, CheckCircleOutlined, SendOutlined, LockOutlined, LoadingOutlined } from "@ant-design/icons";
import { Wrapper } from "../style";
import { MakeApiCall } from "../../../../apis";
import { primaryColor } from "../../../../config";

const { Option } = Select;

// Common country codes — code only, no flags
const COUNTRY_CODES = [
    { code: '+1',   country: 'US/CA' },
    { code: '+7',   country: 'Russia' },
    { code: '+20',  country: 'Egypt' },
    { code: '+27',  country: 'South Africa' },
    { code: '+30',  country: 'Greece' },
    { code: '+31',  country: 'Netherlands' },
    { code: '+32',  country: 'Belgium' },
    { code: '+33',  country: 'France' },
    { code: '+34',  country: 'Spain' },
    { code: '+36',  country: 'Hungary' },
    { code: '+39',  country: 'Italy' },
    { code: '+40',  country: 'Romania' },
    { code: '+41',  country: 'Switzerland' },
    { code: '+43',  country: 'Austria' },
    { code: '+44',  country: 'UK' },
    { code: '+45',  country: 'Denmark' },
    { code: '+46',  country: 'Sweden' },
    { code: '+47',  country: 'Norway' },
    { code: '+48',  country: 'Poland' },
    { code: '+49',  country: 'Germany' },
    { code: '+51',  country: 'Peru' },
    { code: '+52',  country: 'Mexico' },
    { code: '+54',  country: 'Argentina' },
    { code: '+55',  country: 'Brazil' },
    { code: '+56',  country: 'Chile' },
    { code: '+57',  country: 'Colombia' },
    { code: '+60',  country: 'Malaysia' },
    { code: '+61',  country: 'Australia' },
    { code: '+62',  country: 'Indonesia' },
    { code: '+63',  country: 'Philippines' },
    { code: '+64',  country: 'New Zealand' },
    { code: '+65',  country: 'Singapore' },
    { code: '+66',  country: 'Thailand' },
    { code: '+81',  country: 'Japan' },
    { code: '+82',  country: 'South Korea' },
    { code: '+84',  country: 'Vietnam' },
    { code: '+86',  country: 'China' },
    { code: '+90',  country: 'Turkey' },
    { code: '+91',  country: 'India' },
    { code: '+92',  country: 'Pakistan' },
    { code: '+93',  country: 'Afghanistan' },
    { code: '+94',  country: 'Sri Lanka' },
    { code: '+95',  country: 'Myanmar' },
    { code: '+98',  country: 'Iran' },
    { code: '+212', country: 'Morocco' },
    { code: '+213', country: 'Algeria' },
    { code: '+216', country: 'Tunisia' },
    { code: '+218', country: 'Libya' },
    { code: '+220', country: 'Gambia' },
    { code: '+234', country: 'Nigeria' },
    { code: '+254', country: 'Kenya' },
    { code: '+255', country: 'Tanzania' },
    { code: '+256', country: 'Uganda' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' },
    { code: '+351', country: 'Portugal' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+353', country: 'Ireland' },
    { code: '+358', country: 'Finland' },
    { code: '+380', country: 'Ukraine' },
    { code: '+381', country: 'Serbia' },
    { code: '+385', country: 'Croatia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+421', country: 'Slovakia' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+971', country: 'UAE' },
    { code: '+972', country: 'Israel' },
    { code: '+973', country: 'Bahrain' },
    { code: '+974', country: 'Qatar' },
    { code: '+975', country: 'Bhutan' },
    { code: '+977', country: 'Nepal' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+998', country: 'Uzbekistan' },
];

function AddNewAlerts({
    isModalVisible,
    handleCancel,
    handleSubmit,
    editing,
    userData,
    asinList,
    alertCategories,
    alertDataMap,
    fetchProductList,
    isSearching,
    hasMore,
    page,
    searchText
}) {

    const [form] = Form.useForm();
    const receiveOnWatch = Form.useWatch('receive_on', form);
    const [alertTypes, setAlertTypes] = useState({});
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedAlertType, setSelectedAlertType] = useState(null);
    const [alertLogicType, setAlertLogicType] = useState(null);
    const [localSelectedAsins, setLocalSelectedAsins] = useState([]);

    // ASIN preset state
    const [selectedPreset, setSelectedPreset] = useState(null);
    const [byTagInput, setByTagInput] = useState('');
    const [presetLoading, setPresetLoading] = useState(false);
    
    // Email management
    const [emails, setEmails] = useState([]);
    const [pendingEmail, setPendingEmail] = useState(null);
    const [emailInput, setEmailInput] = useState('');
    const [emailSuggestions, setEmailSuggestions] = useState([]);
    const [emailOtpCode, setEmailOtpCode] = useState('');
    const [emailOtpLoading, setEmailOtpLoading] = useState(false);
    const [preVerifiedEmails, setPreVerifiedEmails] = useState([]);
    const [showEmailOtp, setShowEmailOtp] = useState(false);
    
    // WhatsApp management
    const [whatsappNumbers, setWhatsappNumbers] = useState([]);
    const [pendingWhatsapp, setPendingWhatsapp] = useState(null);
    const [whatsappCountryCode, setWhatsappCountryCode] = useState('+91');
    const [whatsappInput, setWhatsappInput] = useState('');
    const [whatsappSuggestions, setWhatsappSuggestions] = useState([]);
    const [mobileOtpCode, setMobileOtpCode] = useState('');
    const [mobileOtpLoading, setMobileOtpLoading] = useState(false);
    const [preVerifiedMobiles, setPreVerifiedMobiles] = useState([]);
    const [showMobileOtp, setShowMobileOtp] = useState(false);
    
    // Suggestions state
    const [allEmailSuggestions, setAllEmailSuggestions] = useState([]);
    const [allMobileSuggestions, setAllMobileSuggestions] = useState([]);
    const [suggestionsLoading, setSuggestionsLoading] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false; };
    }, []);

   // Move the fetchSuggestions logic outside useEffect as a separate function
const fetchSuggestions = useCallback(async () => {
    setSuggestionsLoading(true);
    try {
        const response = await MakeApiCall(
            'get-contact-details-suggestions',
            'get',
            null,
            true,
            {},
            userData?.token
        );
        if (!isMounted.current) return;
        if (response?.status) {
            const emails = (response.data?.emails || []).map(e => ({ value: e, label: e }));
            const mobiles = (response.data?.mobile_numbers || []).map(n => ({ value: n, label: n }));
            setAllEmailSuggestions(emails);
            setEmailSuggestions(emails);
            setAllMobileSuggestions(
                mobiles.map(m => {
                    const value = m.value.includes('-') ? m.value.split('-').slice(1).join('-') : m.value;
                    return { ...m, value, label: value };
                })
            );
            setWhatsappSuggestions(
                mobiles.map(m => {
                    const value = m.value.includes('-') ? m.value.split('-').slice(1).join('-') : m.value;
                    return { ...m, value, label: value };
                })
            );
            
            setPreVerifiedEmails(response.data?.emails || []);
            setPreVerifiedMobiles(
                (response.data?.mobile_numbers || []).map(mobile => {
                    const parts = mobile.split('-');
                    return parts.length > 1 ? parts.slice(1).join('-') : mobile;
                })
            );
        }
    } catch (e) {
        console.error('Failed to fetch contact suggestions:', e);
    } finally {
        if (isMounted.current) setSuggestionsLoading(false);
    }
}, [userData?.token]); // Add dependencies

// Then update the useEffect to use this function
useEffect(() => {
    if (!isModalVisible) return;
    fetchSuggestions();
}, [isModalVisible, fetchSuggestions]);



    const sanitizeTags = (raw) =>
        (raw || '')
            .split(',')
            .map(t => t.trim())
            .filter(Boolean)
            .join(',');

    const fetchAsinsByPreset = useCallback(async (presetKey, byTagValue) => {
        if (!presetKey) return;
        if (presetKey === 'by_tag') {
            const cleaned = sanitizeTags(byTagValue);
            if (!cleaned) {
                message.warning('Please enter at least one tag');
                return;
            }
        }
        const payload = presetKey === 'by_tag'
            ? { preset: 'by_tag', tag: sanitizeTags(byTagValue) }
            : { preset: presetKey };

        setPresetLoading(true);
        try {
            const response = await MakeApiCall(
                'products/asin-list-by-preset',
                'post',
                payload,
                true,
                {},
                userData?.token
            );
            if (response?.status) {
                const asins = Array.isArray(response?.data?.asins) ? [...response.data.asins] : [];
                setLocalSelectedAsins(asins);
                message.success(response?.message || 'ASIN list loaded.');
            } else {
                message.error(response?.message || 'Failed to load ASIN list');
            }
        } catch (e) {
            message.error('Failed to load ASIN list');
        } finally {
            setPresetLoading(false);
        }
    }, [userData?.token]);

    const handlePresetChange = (value) => {
        setSelectedPreset(value);
        setByTagInput('');
        if (!value) {
            setLocalSelectedAsins([]);
            return;
        }
        if (value !== 'by_tag') {
            fetchAsinsByPreset(value);
        }
    };

    const handlePopupScroll = useCallback((e) => {
        const { target } = e;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
            if (!isSearching && hasMore) {
                fetchProductList(searchText, page + 1, true);
            }
        }
    }, [isSearching, hasMore, page, searchText, fetchProductList]);

    useEffect(() => {
        const types = {};
        Object.entries(alertDataMap.types).forEach(([category, typeMap]) => {
            types[category] = Object.entries(typeMap).map(([key, label]) => ({
                label,
                value: key
            }));
        });
        setAlertTypes(types);

        if (editing) {
            let asinArray = [];
            try {
                asinArray = typeof editing.asin_list === "string" ? JSON.parse(editing.asin_list) : editing.asin_list;
            } catch (err) {
                console.error("Failed to parse asin_list:", err);
            }
            setLocalSelectedAsins(Array.isArray(asinArray) ? asinArray : []);
            const logic = alertDataMap.logicTypeMap?.[editing.type]?.type || "Default";
            setAlertLogicType(logic);
        } else {
            setLocalSelectedAsins([]);
            setAlertLogicType(null);
        }
    }, [alertDataMap.types, alertDataMap.logicTypeMap, editing]);

    useEffect(() => {
        if (editing) {
            let frequencyValue = 2;
            let daysValue = null;

            if (editing.frequency !== "Everytime") {
                frequencyValue = 1;
                daysValue = parseInt(editing.frequency, 10);
            }

            let emailList = [];
            if (editing?.send_on_emails) {
                if (Array.isArray(editing.send_on_emails)) {
                    emailList = editing.send_on_emails;
                } else if (typeof editing.send_on_emails === 'string') {
                    emailList = editing.send_on_emails.split(',').map(e => e.trim());
                }
            }
            setEmails(emailList);

            let whatsappList = [];
            if (editing?.send_on_mobile_numbers) {
                if (Array.isArray(editing.send_on_mobile_numbers)) {
                    whatsappList = editing.send_on_mobile_numbers;
                } else if (typeof editing.send_on_mobile_numbers === 'string') {
                    whatsappList = editing.send_on_mobile_numbers.split(',').map(w => w.trim());
                }
            } else if (editing?.send_on_mobile_number) {
                whatsappList = [editing.send_on_mobile_number];
            }
            setWhatsappNumbers(whatsappList);

            form.setFieldsValue({
                ...editing,
                alertType: editing.type,
                frequency: frequencyValue,
                days: daysValue,
                receive_on: editing.receive_on || [],
                severity: editing.severity || "Medium",
            });

            setSelectedCategory(editing.category);
            setSelectedAlertType(editing.type);
        } else {
            form.resetFields();
            setSelectedCategory(null);
            setSelectedAlertType(null);
            setAlertLogicType(null);
            setSelectedPreset(null);
            setByTagInput('');
            setEmails([]);
            setWhatsappNumbers([]);
            setEmailInput('');
            setWhatsappInput('');
            setWhatsappCountryCode('+91');
            setPendingEmail(null);
            setPendingWhatsapp(null);
            setShowEmailOtp(false);
            setShowMobileOtp(false);
            setEmailOtpCode('');
            setMobileOtpCode('');
            form.setFieldsValue({
                frequency: 2,
                severity: "Medium",
            });
        }
    }, [editing, isModalVisible]);

    // Email OTP handlers
    const sendEmailOTP = async (email) => {
        setEmailOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/send-email-otp',
                'post',
                { email: email },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('OTP sent successfully to your email!');
                setPendingEmail(email);
                setShowEmailOtp(true);

            } else {
                message.error(response?.message || 'Failed to send OTP');
            }
        } catch (error) {
            message.error('Failed to send OTP');
        } finally {
            setEmailOtpLoading(false);
        }
    };

    const verifyEmailOTP = async () => {
        if (!emailOtpCode || emailOtpCode.length !== 6) {
            message.warning('Please enter a valid 6-digit OTP');
            return;
        }
        
        setEmailOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/verify-email-otp',
                'post',
                { 
                    email: pendingEmail,
                    otp: emailOtpCode 
                },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('Email verified successfully!');
                setEmails([...emails, pendingEmail]);
                setEmailInput('');
                setPendingEmail(null);
                setShowEmailOtp(false);
                setEmailOtpCode('');

                // Refresh suggestions after successful verification
                await fetchSuggestions();

            } else {
                message.error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            message.error('Failed to verify OTP');
        } finally {
            setEmailOtpLoading(false);
        }
    };

    const handleAddEmail = async () => {
        if (!emailInput || !emailInput.trim()) {
            message.warning('Please enter an email address');
            return;
        }
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(emailInput)) {
            message.error('Please enter a valid email address');
            return;
        }
        
        if (emails.includes(emailInput)) {
            message.warning('Email already exists and verified');
            return;
        }
        
        if (pendingEmail === emailInput && showEmailOtp) {
            message.warning('Email is already pending verification');
            return;
        }
        
        if (preVerifiedEmails.includes(emailInput)) {
            setEmails([...emails, emailInput]);
            setEmailInput('');
            message.success('Email added successfully!');
            return;
        }
        
        await sendEmailOTP(emailInput);
    };

    const handleRemoveEmail = (emailToRemove) => {
        setEmails(emails.filter(email => email !== emailToRemove));
    };

    const handleCancelEmailOtp = () => {
        setShowEmailOtp(false);
        setEmailOtpCode('');
        setPendingEmail(null);
    };

    // Mobile OTP handlers
    const sendMobileOTP = async (mobileNumber, countryCode) => {
        const fullNumber = `${countryCode}${mobileNumber}`;
        setMobileOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/send-mobile-otp',
                'post',
                { contact_no: fullNumber },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('OTP sent successfully to your mobile number!');

                setPendingWhatsapp({ number: mobileNumber, countryCode, fullNumber });
                setShowMobileOtp(true);
            } else {
                message.error(response?.message || 'Failed to send OTP');
            }
        } catch (error) {
            message.error('Failed to send OTP');
        } finally {
            setMobileOtpLoading(false);
        }
    };

    const verifyMobileOTP = async () => {
        if (!mobileOtpCode || mobileOtpCode.length !== 6) {
            message.warning('Please enter a valid 6-digit OTP');
            return;
        }
        
        setMobileOtpLoading(true);
        try {
            const response = await MakeApiCall(
                'verification/verify-mobile-otp',
                'post',
                { 
                    contact_no: pendingWhatsapp.fullNumber,
                    otp: mobileOtpCode 
                },
                true,
                {},
                userData?.token
            );
            
            if (response?.status) {
                message.success('Mobile number verified successfully!');
                const fullNumberWithCode = `${pendingWhatsapp.countryCode}-${pendingWhatsapp.number}`;
                setWhatsappNumbers([...whatsappNumbers, fullNumberWithCode]);
                setWhatsappInput('');
                setPendingWhatsapp(null);
                setShowMobileOtp(false);
                setMobileOtpCode('');

                // Refresh suggestions after successful verification
                await fetchSuggestions();
            } else {
                message.error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            message.error('Failed to verify OTP');
        } finally {
            setMobileOtpLoading(false);
        }
    };

    // Fixed handleAddWhatsapp function
const handleAddWhatsapp = async () => {
    if (!whatsappInput || !whatsappInput.trim()) {
        message.warning('Please enter a WhatsApp number');
        return;
    }
    
    const numberRegex = /^[0-9]{6,14}$/;
    if (!numberRegex.test(whatsappInput)) {
        message.error('Please enter a valid number (6-14 digits only)');
        return;
    }
    
    const fullNumberWithHyphen = `${whatsappCountryCode}-${whatsappInput}`;
    const fullNumberWithoutHyphen = `${whatsappCountryCode}${whatsappInput}`;
    
    if (whatsappNumbers.includes(fullNumberWithHyphen)) {
        message.warning('WhatsApp number already exists and verified');
        return;
    }
    
    if (pendingWhatsapp && pendingWhatsapp.number === whatsappInput && pendingWhatsapp.countryCode === whatsappCountryCode && showMobileOtp) {
        message.warning('Number is already pending verification');
        return;
    }
    
    // Check if mobile is pre-verified (compare both formats)
    const isPreVerified = preVerifiedMobiles.some(preVerified => 
        preVerified === fullNumberWithoutHyphen || 
        preVerified === whatsappInput ||
        preVerified === fullNumberWithHyphen
    );
    
    if (isPreVerified) {
        setWhatsappNumbers([...whatsappNumbers, fullNumberWithHyphen]);
        setWhatsappInput('');
        message.success('WhatsApp number added successfully!');
        return;
    }
    
    // Send OTP only for new numbers
    await sendMobileOTP(whatsappInput, whatsappCountryCode);
};

    const handleRemoveWhatsapp = (whatsappToRemove) => {
        setWhatsappNumbers(whatsappNumbers.filter(whatsapp => whatsapp !== whatsappToRemove));
    };

    const handleCancelMobileOtp = () => {
        setShowMobileOtp(false);
        setMobileOtpCode('');
        setPendingWhatsapp(null);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            
            if (values.receive_on?.includes('Email') && emails.length === 0) {
                message.error('Please add at least one email address');
                return;
            }
            
            if (values.receive_on?.includes('Whatsapp') && whatsappNumbers.length === 0) {
                message.error('Please add at least one WhatsApp number');
                return;
            }

            if (showEmailOtp || showMobileOtp) {
                message.warning('Please complete pending verifications');
                return;
            }

            const payload = {
                name: values.name,
                category: values.category,
                type: values.alertType,
                frequency: values.frequency === 1 ? `${values.days}` : "Everytime",
                receive_on: values.receive_on || [],
                asin_list: localSelectedAsins || [],
                severity: values.severity,
                send_on_emails: emails,
                send_on_mobile_numbers: whatsappNumbers,
            };

            if (alertDataMap.logicTypeMap?.[values.alertType]?.type === "Custom") {
                payload.user_input = values.user_input;
            }

            handleSubmit(payload);
        } catch (errorInfo) {
            console.log("Validation Failed:", errorInfo);
        }
    };

    return (
        <Modal
            open={isModalVisible}
            title={editing ? "Edit Alerts" : "Add New Alerts"}
            onCancel={handleCancel}
            width={750}
            destroyOnClose
            footer={[
                <React.Fragment key="footer-btns">
                    <button type="button" className="btn btn-light me-3" onClick={handleCancel}>Close</button>
                    <button type="button" className="btn btn-danger" onClick={handleOk}>{editing ? "Update" : "Save"}</button>
                </React.Fragment>
            ]}
        >
            <Wrapper>
                <div className="modal_custom add-alert">
                    <Form form={form} layout="vertical" name="expenseForm" initialValues={{ frequency: 2, severity: "Medium" }}>
                        <div className="row g-5 mb-0 align-items-center">
                            <div className="col-md-12">
                                <Form.Item label="" name="name" className="mb-0 fw-bold"
                                           rules={[{required: true, message: "Please enter alert name"}]}>
                                    <Input className="form-control form-control-solid fs-7"
                                           placeholder="Enter Alert Name"/>
                                </Form.Item>
                            </div>

                            <div className="col-md-6">
                                <Form.Item shouldUpdate={() => true} noStyle>
                                    {({ getFieldError }) => {
                                        const errors = getFieldError('category');
                                        return (
                                            <Form.Item
                                                label=""
                                                required
                                                className="mb-4 fw-bold"
                                                validateStatus={errors.length ? "error" : ""}
                                                help={errors.length > 0 && (
                                                    <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                        {errors[0]}
                                                    </div>
                                                )}
                                            >
                                                <Form.Item name="category" noStyle rules={[{ required: true, message: "Please select a category" }]}>
                                                    <Select
                                                        placeholder="Select Category"
                                                        onChange={(value) => {
                                                            setSelectedCategory(value);
                                                            form.setFieldsValue({alertType: undefined});
                                                        }}
                                                    >
                                                        {alertCategories.map(option => (
                                                            <Option key={option.value} value={option.value}>{option.label}</Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Form.Item>
                                        );
                                    }}
                                </Form.Item>
                            </div>

                            <div className="col-md-6">
                                <Form.Item shouldUpdate={() => true} noStyle>
                                    {({ getFieldError }) => {
                                        const errors = getFieldError('alertType');
                                        return (
                                            <Form.Item
                                                label=""
                                                required
                                                className="mb-4"
                                                validateStatus={errors.length ? "error" : ""}
                                                help={errors.length > 0 && (
                                                    <div style={{ marginTop: '10px', color: '#ff4d4f' }}>
                                                        {errors[0]}
                                                    </div>
                                                )}
                                            >
                                                <Form.Item name="alertType" noStyle rules={[{ required: true, message: "Please select an alert type" }]}>
                                                    <Select
                                                        placeholder="Select Alert Type"
                                                        disabled={!selectedCategory}
                                                        onChange={(value) => {
                                                            setSelectedAlertType(value);
                                                            const logic = alertDataMap.logicTypeMap?.[value]?.type || "Default";
                                                            setAlertLogicType(logic);
                                                            form.setFieldsValue({user_input: null});
                                                        }}
                                                    >
                                                        {alertTypes[selectedCategory]?.map((option) => (
                                                            <Option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </Option>
                                                        )) || null}
                                                    </Select>
                                                </Form.Item>
                                            </Form.Item>
                                        );
                                    }}
                                </Form.Item>
                            </div>

                            {Object.keys(alertDataMap.asinPresets || {}).length > 0 && (
                                <div className="col-md-12">
                                    <div className="fw-bold mb-2">ASIN Scope</div>
                                    <Row gutter={8}>
                                        <Col span={selectedPreset === 'by_tag' ? 10 : 24}>
                                            <Select
                                                placeholder="Select ASIN scope"
                                                className="w-100"
                                                size="large"
                                                allowClear
                                                value={selectedPreset}
                                                onChange={handlePresetChange}
                                                loading={presetLoading}
                                            >
                                                {Object.entries(alertDataMap.asinPresets).map(([key, label]) => (
                                                    <Option key={key} value={key}>{label}</Option>
                                                ))}
                                            </Select>
                                        </Col>
                                        {selectedPreset === 'by_tag' && (
                                            <>
                                                <Col span={10}>
                                                    <Input
                                                        size="large"
                                                        placeholder="Enter tags (comma separated, e.g. Tag1,tag2)"
                                                        value={byTagInput}
                                                        onChange={(e) => setByTagInput(e.target.value)}
                                                        onPressEnter={() => fetchAsinsByPreset('by_tag', byTagInput)}
                                                    />
                                                </Col>
                                                <Col span={4}>
                                                    <Button
                                                        type="primary"
                                                        danger
                                                        block
                                                        size="large"
                                                        loading={presetLoading}
                                                        onClick={() => fetchAsinsByPreset('by_tag', byTagInput)}
                                                    >
                                                        Apply
                                                    </Button>
                                                </Col>
                                            </>
                                        )}
                                    </Row>
                                </div>
                            )}

                            <div className="col-md-12">
                                <Form.Item className="fw-bold mb-4" label="">
                                    <Spin
                                        spinning={presetLoading}
                                        tip="Loading ASINs..."
                                        indicator={<LoadingOutlined style={{ fontSize: 24, color: primaryColor }} spin />}
                                        style={{ color: primaryColor }}
                                    >
                                    <Select
                                        mode="tags"
                                        showSearch
                                        placeholder={presetLoading ? "Loading ASINs..." : "Search SKU, Title or ASIN"}
                                        className="w-100"
                                        size="large"
                                        value={localSelectedAsins}
                                        onChange={setLocalSelectedAsins}
                                        onSearch={(val) => fetchProductList(val, 1, false)}
                                        onPopupScroll={handlePopupScroll}
                                        filterOption={false}
                                        disabled={presetLoading}
                                        loading={isSearching || presetLoading}
                                        optionLabelProp="value"
                                        maxTagCount={"responsive"}
                                        tokenSeparators={[',']}
                                        notFoundContent={isSearching ? <div className="text-center p-2"><Spin size="small"/></div> : null}
                                    >
                                        {asinList.map((item) => (
                                            <Option key={item.asin} value={item.asin}>
                                                <div className="d-flex align-items-center gap-3">
                                                    <img
                                                        src={item.image || "https://app.sellerview.ai/sellerview_api/images/no-product-image.png"}
                                                        alt=""
                                                        className="w-40px h-40px rounded border object-fit-contain"
                                                    />
                                                    <div className="flex-grow-1" style={{minWidth: 0}}>
                                                        <div className="fw-bolder text-dark text-truncate" style={{fontSize: '12px'}}>
                                                            {item.name}
                                                        </div>
                                                        <div className="fs-12 text-muted d-flex align-items-center" style={{gap: '8px'}}>
                                                            <span className="badge badge-light-danger fw-bold">{item.asin}</span>
                                                            {item.sku && (
                                                                <span className="text-truncate" style={{maxWidth: '160px'}}>
                                                                    <small>SKU: <span className="fw-bold text-dark">{item.sku}</span></small>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Option>
                                        ))}
                                        {isSearching && hasMore && (
                                            <Option disabled key="loading-more" className="text-center bg-light">
                                                <Spin size="small" /> <small className="ms-2">Loading more...</small>
                                            </Option>
                                        )}
                                    </Select>
                                    </Spin>
                                </Form.Item>
                            </div>

                            <div className="col-md-12">
                                {alertLogicType === "Custom" && (
                                    <div className="col-md-12">
                                        <Form.Item
                                            label=""
                                            name="user_input"
                                            className="mb-4"
                                            rules={[{required: true, message: "Please enter a threshold value"}]}
                                        >
                                            <Space>
                                                <div className="fw-bold fs-7">
                                                    {alertDataMap.logicTypeMap?.[selectedAlertType]?.description || "Enter threshold percentage"}
                                                </div>
                                                <Input
                                                    type="number"
                                                    className="w-125px fs-7"
                                                    placeholder="Percentage"
                                                    suffix="%"
                                                    variant="filled"
                                                    size="large"
                                                />
                                            </Space>
                                        </Form.Item>
                                    </div>
                                )}
                            </div>

                            <div className="col-md-12">
                                <Form.Item name="frequency" className="d-flex align-items-center fw-bold">
                                    <Radio.Group name="notificationFrequency">
                                        <Space direction="vertical">
                                            <Radio value={1}>
                                                Send me a notification every
                                                <Form.Item noStyle shouldUpdate={(p, c) => p.frequency !== c.frequency}>
                                                    {({getFieldValue}) => (
                                                        <Form.Item
                                                            name="days"
                                                            noStyle
                                                            rules={[{ required: getFieldValue('frequency') === 1, message: "Required" }]}
                                                        >
                                                            <Input
                                                                type="number"
                                                                min={1}
                                                                className="w-125px mx-3 fs-7"
                                                                variant="filled"
                                                                disabled={getFieldValue('frequency') !== 1}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </Form.Item>
                                                day(s)
                                            </Radio>
                                            <Radio className="mt-3" value={2}>
                                                Send me a notification every time the change happens.
                                            </Radio>
                                        </Space>
                                    </Radio.Group>
                                </Form.Item>
                            </div>

                            {/* <div className="col-md-12">
                                <Form.Item
                                    name="severity"
                                    label="Severity"
                                    className="fw-bold"
                                    rules={[{required: true, message: "Please select a severity level"}]}
                                >
                                    <Radio.Group>
                                        <Radio value="Minor">Minor</Radio>
                                        <Radio value="Major">Major</Radio>
                                        <Radio value="Critical">Critical</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </div> */}

                            <div className="col-md-12">
                                <Form.Item name="receive_on" className="fw-bold" label="Receive Alert On">
                                    <Checkbox.Group>
                                        {alertDataMap.receive_on.map((option) => (
                                            <Checkbox key={option} value={option}>{option}</Checkbox>
                                        ))}
                                    </Checkbox.Group>
                                </Form.Item>
                            </div>

                            {/* Email field with OTP section integrated */}
                            {receiveOnWatch?.includes('Email') && (
                                <div className="col-md-12">
                                    <div className="fw-bold mb-2 d-flex align-items-center">
                                        <i className="ki-outline ki-sms fs-2 me-2"></i>
                                        <div>Email Addresses</div>
                                    </div>
                                    
                                    {emails.length > 0 && (
                                        <div className="mb-3">
                                            <div className="text-muted mb-2 small">Verified Emails:</div>
                                            {emails.map((email, index) => (
                                                <div key={index} className="mb-2 d-flex align-items-center justify-content-between" style={{ padding: '8px', backgroundColor: '#f0f9f0', borderRadius: '4px', border: '1px solid #b7eb8f' }}>
                                                    <div className="d-flex align-items-center">
                                                        <CheckCircleOutlined className="text-success me-2" />
                                                        <span>{email}</span>
                                                        <Tag color="success" className="ms-2" style={{ fontSize: '10px' }}>Verified</Tag>
                                                    </div>
                                                    <Button 
                                                        type="text" 
                                                        danger 
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => handleRemoveEmail(email)}
                                                        size="small"
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <div className="text-muted mb-2 small">Add New Email:</div>
                                        <Row gutter={8}>
                                            <Col span={18}>
                                                <AutoComplete
                                                    style={{ width: '100%' }}
                                                    options={emailSuggestions}
                                                    onSearch={(searchVal) => {
                                                        if (!searchVal) {
                                                            setEmailSuggestions(allEmailSuggestions);
                                                        } else {
                                                            setEmailSuggestions(
                                                                allEmailSuggestions.filter(s =>
                                                                    s.value.toLowerCase().includes(searchVal.toLowerCase())
                                                                )
                                                            );
                                                        }
                                                    }}
                                                    value={emailInput}
                                                    onChange={setEmailInput}
                                                    placeholder="Enter email address"
                                                    notFoundContent={suggestionsLoading ? <div className="text-center p-2"><Spin size="small" /></div> : null}
                                                />
                                            </Col>
                                            <Col span={6}>
                                                <Button 
                                                    type="primary" 
                                                    icon={preVerifiedEmails.includes(emailInput) ? <PlusOutlined /> : <SendOutlined />}
                                                    onClick={handleAddEmail}
                                                    loading={emailOtpLoading && !showEmailOtp}
                                                    block
                                                    danger
                                                    className="h-40px"
                                                >
                                                    {preVerifiedEmails.includes(emailInput) ? "Add Email" : "Verify Email"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Integrated Email OTP Section */}
                                    {showEmailOtp && pendingEmail && (
                                        <AntAlert
                                            message="Email Verification Required"
                                            description={
                                                <div className="mt-2">
                                                    <p className="mb-3">We've sent a 6-digit OTP to <strong>{pendingEmail}</strong></p>
                                                    <Row gutter={8}>
                                                        <Col span={12}>
                                                            <Input.OTP
                                                                inputType="numeric"
                                                                length={6}
                                                                value={emailOtpCode}
                                                                onChange={setEmailOtpCode}
                                                                className="w-100"
                                                                style={{ fontSize: '20px', letterSpacing: '4px' }}
                                                                autoFocus
                                                                size="large"
                                                            />
                                                        </Col>
                                                        <Col span={6}>
                                                            <Button 
                                                                type="primary"
                                                                onClick={verifyEmailOTP}
                                                                loading={emailOtpLoading}
                                                                block
                                                                danger
                                                                className="h-35px"
                                                            >
                                                                Verify
                                                            </Button>
                                                        </Col>
                                                        <Col span={6}>
                                                            <Button 
                                                                onClick={handleCancelEmailOtp}
                                                                block
                                                                className="h-35px"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <div className="mt-2">
                                                        <Button 
                                                            type="link" 
                                                            onClick={() => sendEmailOTP(pendingEmail)}
                                                            disabled={emailOtpLoading}
                                                            className="p-0 text-dark text-hover-danger"
                                                        >
                                                            Resend OTP
                                                        </Button>
                                                    </div>
                                                </div>
                                            }
                                            type="error"
                                            showIcon
                                            icon={<i className="ki-outline ki-sms fs-2x mt-5"></i>}
                                       
                                            className="mt-3"
                                            // closable
                                            onClose={handleCancelEmailOtp}
                                        />
                                    )}
                                </div>
                            )}

                            {/* WhatsApp field with OTP section integrated */}
                            {receiveOnWatch?.includes('Whatsapp') && (
                                <div className="col-md-12">
                                    <div className="fw-bold mb-2 d-flex align-items-center">
                                        <i className="ki-outline ki-phone fs-2 me-2"></i>
                                        <div>WhatsApp Numbers</div>
                                    </div>
                                    
                                    
                                    {whatsappNumbers.length > 0 && (
                                        <div className="mb-3">
                                            <div className="text-muted mb-2 small">Verified Numbers:</div>
                                            {whatsappNumbers.map((whatsapp, index) => {
                                                const [code, number] = whatsapp.split('-');
                                                return (
                                                    <div key={index} className="mb-2 d-flex align-items-center justify-content-between" style={{ padding: '8px', backgroundColor: '#f0f9f0', borderRadius: '4px', border: '1px solid #b7eb8f' }}>
                                                        <div className="d-flex align-items-center">
                                                            <CheckCircleOutlined className="text-success me-2" />
                                                            <span>{code} {number}</span>
                                                            <Tag color="success" className="ms-2" style={{ fontSize: '10px' }}>Verified</Tag>
                                                        </div>
                                                        <Button 
                                                            type="text" 
                                                            danger 
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleRemoveWhatsapp(whatsapp)}
                                                            size="small"
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <div className="text-muted mb-2 small">Add New Number:</div>
                                        <Row gutter={8}>
                                            <Col span={6}>
                                                <Select
                                                    value={whatsappCountryCode}
                                                    onChange={setWhatsappCountryCode}
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option?.value?.includes(input)
                                                    }
                                                    style={{ width: '100%' }}
                                                    dropdownStyle={{ minWidth: 110 }}
                                                    popupMatchSelectWidth={false}
                                                >
                                                    {COUNTRY_CODES.map(({ code }) => (
                                                        <Option key={code} value={code}>{code}</Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                            <Col span={12}>
                                                <AutoComplete
                                                    style={{ width: '100%' }}
                                                    options={whatsappSuggestions}
                                                    onSearch={(searchVal) => {
                                                        if (!searchVal) {
                                                            setWhatsappSuggestions(allMobileSuggestions);
                                                        } else {
                                                            setWhatsappSuggestions(
                                                                allMobileSuggestions.filter(s =>
                                                                    s.value.includes(searchVal)
                                                                )
                                                            );
                                                        }
                                                    }}
                                                    value={whatsappInput}
                                                    onChange={setWhatsappInput}
                                                    placeholder="Enter WhatsApp number"
                                                    notFoundContent={suggestionsLoading ? <div className="text-center p-2"><Spin size="small" /></div> : null}
                                                />
                                            </Col>
                                            <Col span={6}>
                                            <Button 
                                                type="primary" 
                                                danger
                                                icon={(() => {
                                                    return preVerifiedMobiles.includes(whatsappInput) ? <PlusOutlined /> : <SendOutlined />;
                                                })()}
                                                onClick={handleAddWhatsapp}
                                                loading={mobileOtpLoading && !showMobileOtp}
                                                block
                                                className="h-40px"
                                            >
                                                {(() => {
                                                    return preVerifiedMobiles.includes(whatsappInput) ? "Add Number" : "Verify Number";
                                                })()}
                                            </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    
                                    {/* Integrated Mobile OTP Section */}
                                    {showMobileOtp && pendingWhatsapp && (
                                        <AntAlert
                                            message="Mobile Number Verification Required"
                                            description={
                                                <div className="mt-2">
                                                    <p className="mb-2">We've sent a 6-digit OTP to <strong>{pendingWhatsapp.countryCode} {pendingWhatsapp.number}</strong></p>
                                                    <Row gutter={8}>
                                                        <Col span={12}>
                                                            <Input.OTP
                                                                inputType="numeric"
                                                                length={6}
                                                                value={mobileOtpCode}
                                                                onChange={setMobileOtpCode}
                                                                className="w-100"
                                                                style={{ fontSize: '20px', letterSpacing: '4px' }}
                                                                autoFocus
                                                                size="large"
                                                            />
                                                        </Col>
                                                        <Col span={6}>
                                                            <Button 
                                                                type="primary"
                                                                onClick={verifyMobileOTP}
                                                                loading={mobileOtpLoading}
                                                                block
                                                                danger
                                                                className="h-35px"
                                                            >
                                                                Verify
                                                            </Button>
                                                        </Col>
                                                        <Col span={6}>
                                                            <Button 
                                                                onClick={handleCancelMobileOtp}
                                                                block
                                                                className="h-35px"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <div className="mt-2">
                                                        <Button 
                                                            type="link" 
                                                            onClick={() => sendMobileOTP(pendingWhatsapp.number, pendingWhatsapp.countryCode)}
                                                            disabled={mobileOtpLoading}
                                                            className="p-0 text-dark text-hover-danger"
                                                        >
                                                            Resend OTP
                                                        </Button>
                                                    </div>
                                                </div>
                                            }
                                            type="error"
                                            showIcon
                                            icon={<i className="ki-outline ki-phone fs-2x mt-5"></i>}                                       
                                            className="mt-3"
                                            onClose={handleCancelMobileOtp}
                                        />
                                    )}

                                </div>
                            )}
                        </div>
                    </Form>
                </div>
            </Wrapper>
        </Modal>
    );
}

export default AddNewAlerts;